import styled from "styled-components";

import { flex, flexAlign, flexBetween, flexJustAlign, FlexWrapper } from "@/components/css.common";
import IconSuccess from "@/static/images/success.png";

export const Root = styled.div`
  padding-top: 215px;

  &.mobile {
    padding: 114px 0 0;

    .apply {
      margin:  0 12px;

      h1 {
        font-size: 22px;
      }

      .desc {
        margin: 20px 0 30px;
        line-height: 14px;
        font-size: 12px;
        text-align: center;

        p:not(:last-child) {
          margin-bottom: 5px;
        }
      }
      
      .actions {
        a {
          width: 135px;
        }
      }
    }

    .guidelines {
      margin-top: 50px;
      padding: 30px 12px;

      h2 {
        font-size: 20px;
        font-weight: normal;
      }

      .desc {
        margin-top: 15px;
        font-size: 12px;
        line-height: 14px;
      }

      .card {
        display: flex;
        margin-top: 30px;
        flex-direction: column;

        dl {
          flex: 1;
          border-radius: 10px;
          margin: 0 0 20px 0;
          padding: 15px;

          &:last-child {
            margin: 0px;
          }
        }

        dt {
          padding-bottom: 15px;
          margin-bottom: 15px;
          line-height: 1;
          font-size: 14px;

          svg {
            margin-right: 10px;
          }
        }

        dd {
          line-height: 16px;
          font-size: 12px;

          p {
            margin-bottom: 12px;

            &:last-child {
              margin-bottom: 0;
            }
          }
        }
      }
    }
  }

  .apply {
    display: flex;
    flex-direction: column;
    align-items: center;

    h1 {
      font-size: 48px;
      color: #333333;
    }

    .desc {
      margin: 35px 0 42px;
      line-height: 20px;
      font-size: 16px;
      color: #666;
    }

    .actions {
      a {
        width: 200px;
        justify-content: center;
      }
    }
  }

  .guidelines {
    margin-top: 110px;
    padding: 80px 0 100px;
    background: #333333;
    color: #fff;

    h2 {
      font-size: 42px;
      line-height: 1;
      font-weight: normal;
    }

    .desc {
      margin-top: 35px;
      font-size: 16px;
      line-height: 26px;
    }

    .card {
      display: flex;
      margin-top: 50px;

      dl {
        flex: 1;
        background-color: #414141;
        border-radius: 10px;
        margin-right: 30px;
        padding: 30px;

        &:last-child {
          margin-right: 0px;
        }
      }

      dt {
        display: flex;
        align-items: center;
        padding-bottom: 20px;
        border-bottom: 1px solid #565656;
        margin-bottom: 20px;
        line-height: 35px;
        font-weight: 500;
        font-size: 26px;

        svg {
          margin-right: 15px;
        }
      }

      dd {
        line-height: 20px;
        font-size: 14px;
        color: #ccc;

        p {
          margin-bottom: 24px;

          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
  }
`

const mobileStyle = {
  root: `
    padding: 0;
  `,
  container: `
    .apply {
      padding: min(10.67vw, 175px) 4vw 0;

      h1 {
        font-size: min(9.6vw, 80px);
        line-height: min(10vw, 94px);
      }
  
      .desc {
        margin-top: min(4vw, 60px);
        line-height: min(5vw, 24px);
        font-size: min(4vw, 20px);

        p {
          margin-bottom: min(3vw, 20px);
        }
      }
  
      .action {
        margin-top: min(5.87vw, 100px);

        a {
          width: min(32vw,200px);
          font-size: min(3.7vw,20px);
          line-height: min(9.6vw,60px);
        }
      }
    }

    .guide {
      margin: min(8vw, 160px) 0;
      padding-top: min(8vw, 60px);
      border-top: 1px solid #eee;

      .desc {
        margin-top: min(4vw, 20px);
        line-height: min(5vw, 20px);
        font-size: min(4vw, 16px);
      }
  
      .card {
        display: block;
        margin-top: min(4vw, 80px);

        dl {
          padding: min(4vw, 30px);
          margin-right: 0;
          margin-bottom: min(4vw, 30px);
          border-radius: min(2vw, 15px);
          box-shadow: min(1.5vw, 11px) min(1.6vw, 14px) min(0.6vw, 5px) 0px rgba(0,0,0,0.05);
        }

        dt {
          padding-bottom: min(4vw, 20px);
          font-size: min(4.27vw, 20px);
          line-height: 1;
        }

        dd {
          line-height: min(4vw, 20px);
          font-size: min(3.73vw, 16px);;
        }

        p {
          margin-top: min(4vw, 20px);
        }
      }
    }
  `,
  form: `
    padding-bottom: 10px;
    margin-top: min(4vw, 30px);
    font-size: min(3.7vw, 16px);
    line-height: 1.1;

    .flex {
      display: block;

      .chunk {
        &:first-child {
          margin-right: 0;
        }
      }
    }

    .chunk {
      margin-top: min(4vw, 30px);
      padding: 15px;
      font-size: 12px;

      .note {
        font-size: 12px;
        margin-top: 15px;
      }

      h1 {
        font-size: 14px;
        margin-bottom: 8px;
      }

      .item {
        margin-bottom: 30px;
      }

      dt {
        margin-bottom: 25px;
        padding: 0;
        font-size: 14px;
      }

      .referral-title {
        margin-bottom : 20px;
        font-size: 12px;
      }

      dd {
        padding: 0;

        .referral {
          border-radius: 5px;
          padding: 0 12px;
        }

        input, select {
          line-height: 35px;
          padding: 0;
          font-size: 12px;
        }
      }

      .twitter {
        margin: min(5.33vw, 30px) 0px;
      }

      .textarea {
        textarea {
          font-size: min(3.7vw, 16px);
        }
      }

      .value {
        display: block;
        margin-top: 10px;

        input {
          &:nth-child(2) {
            margin-top: 10px;
            margin-left: 0;
          }
        }
      }

      .select {
        & > div {
          height: min(8.5vw, 50px);
        }

        .MuiInputLabel-root {
          font-size: min(3vw, 16px);
          transform: translate(min(4vw, 20px), min(2vw, 14px)) scale(1);
        }

        .MuiInputLabel-shrink {
          transform: translate(14px, max(-2vw, -9px)) scale(0.75);
        }

        .MuiSelect-select {
          height: min(8.5vw, 50px);
          line-height: min(8.5vw, 50px);
          padding: 0;
          font-size: min(3vw, 16px);
        }
      }

      .radios {
        &.normal {
          justify-content: space-between;
          
          .radio {
            min-width: min(36vw, 160px);
          }
        }

        .radio {
          margin-bottom: min(4vw, 20px);

          &.other.on {
            padding-bottom: 40px;
          }

          input {
            left: 0;
            top: auto;
            bottom: 0;
            width: 100%;
          }

          i {
            width: min(3.7vw, 18px);
            height: min(3.7vw, 18px);
            margin-right: min(1.5vw, 18px);
            border-width: 1px;
          }
        }

        .on {
          i::after {
            width: min(2.2vw, 10px);
            height: min(2.2vw, 10px);
          }
        }
      }
    }

    .actions {
      margin-top: min(5.33vw, 70px);

      .filled-red  {
        width: 135px;
      }

      .back {
        margin-left: min(8vw, 65px);
        font-size: 15px;
      }
    }
  `,
  success: `
    padding-top: min(32vw, 120px);

    .msg {
      margin-top: min(25vw, 100px);
      font-size: min(4.27vw, 20px);
    }

    .desc {
      font-size: min(4vw, 16px);
    }

    .regards {
      margin-top: min(10.67vw, 60px);
  
      p {
        margin-bottom: min(2.5vw, 16px);
        font-size: min(4.27vw, 20px);
      }
  
      a {
        margin-top: min(10.67vw, 40px);
      }
    }
  `
}

export const ApplyRoot = styled.div`
  padding-top: 105px;

  &.mobile {
    padding: 84px 12px 20px;

    .breadcrumbs {
      margin: 0;
    }

    .bottom {
      padding: 0;
    }
  }

  .bottom {
    padding: 0 0 50px;
  }
`

export const Form = styled.div`
  padding-bottom: 10px;
  margin-top: 18px;
  font-size: 16px;
  color: #666;
  text-align: left;

  &.sm-mobile {
    ${mobileStyle.form}
  }

  .error {
    color: red!important;
    border-color: red!important;

    dd {
      border-color: red!important;
    }

    fieldset {
      border-color: red!important;
    }
  }

  .flex {
    ${flex};

    .chunk {
      flex: 1;
      
      &:first-child {
        margin-right: 24px;
      }
    }
  }

  .chunk {
    margin-top: 40px;
    border: 1px solid #EEEEEE;
    padding: 30px;
    border-radius: 10px 10px 10px 10px;

    h1 {
      margin-bottom: 20px;
      line-height: 1; 
      font-size: 28px;
      color: #333;
    }

    dt {
      ${flexAlign};
      margin-bottom: 40px;
      /* padding: 15px 30px; */
      color: #333333;
      font-weight: bold;
      font-size: 22px;
      /* border: 1px solid #EEEEEE;
      border-bottom: none;
      border-radius: 8px 8px 0 0; */

      span {
        color: red;
      }
    }

    .referral-title {
      margin-bottom : 30px;
      font-weight: normal;
      font-size: 18px;
    }

    dd {
      /* padding: 20px 30px; */
      /* border: 1px solid #EEEEEE; */
      /* border-radius: 0 0 8px 8px; */

      input, select {
        width: 100%;
        box-sizing: border-box;
        border: none;
        padding-bottom: 5px;
        background-color: transparent;
        border-bottom: 1px solid #ccc;
        font-size: 16px;
        color: #333;

        &::placeholder {
          color: #999;
        }
      }

      .referral {
        line-height: 50px;
        border: 1px solid #ccc;
        border-radius: 10px;
        padding: 0 20px;
      }
    }

    .item {
      margin-bottom: 40px;
      
      &:last-child {
        margin-bottom: 0;
      }
    }

    .twitter {
      margin: 53px 0px;
    }

    .label {
      font-weight: bold;
      color: #333;

      span {
        color: red;
      }
    }

    .value {
      ${flexAlign};
      margin-top: 15px;
      input {
        flex: 1;
        border-radius: 0;

        &:nth-child(2) {
          margin-left: 24px;
        }
      }
    }

    .select {
      ${flex};
      width: 100%;
      position: relative;

      & > div {
        height: 50px;
        margin: 0;
        flex: 1;
        position: relative;
        z-index: 1;
        background: transparent;
        cursor: pointer;
      }

      .MuiSelect-select {
        height: 50px;
        line-height: 50px;
        padding: 0;
        color: #666;
      }

      fieldset {
        border-width: 0 0 1px 0;
        border-radius: 0;
        border-color: #ccc;
      }

      .MuiInputLabel-root {
        color: #999;
        transform: translate(0, 16px) scale(1);
      }

      .MuiFormLabel-filled {
        display: none;
      }

      .MuiSvgIcon-root {
        right: 0;
      }
    }

    .textarea {
      position: relative;

      textarea {
        width: 100%;
        background-color: transparent;
        border: none;
        font-size: 16px;
        color: #333;
        outline: none;
        resize: none;

        &::placeholder {
          color: #999;
        }
      }
      .count {
        position: absolute;
        right: 0;
        bottom: 0;
        color: #999999;
      }
    }

    .radios {
      &.normal {
        ${flexAlign};
        flex-wrap: wrap;

        .radio {
          width: 25%;
        }
      }

      .radio {
        ${flexAlign};
        cursor: pointer;
        margin-bottom: 20px;
        position: relative;

        i {
          ${flexAlign};
          justify-content: center;
          width: 18px;
          height: 18px;
          margin-right: 18px;
          box-sizing: border-box;
          border: 2px solid #333333;
          border-radius: 50%;
        }

        input {
          position: absolute;
          left: 120px;
          width: 300px;
          line-height: 30px;
        }
      }

      .on {
        & > span {
          font-weight: bold;
          color: #333;
        }

        i::after {
          content: '';
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background-color: #333333;
        }
      }
    }

    .note {
      margin-top: 20px;
      color: #999;
    }
  }

  .actions {
    ${flexAlign};
    margin-top: 40px;

    .filled-red  {
      width: 200px;
      justify-content: center;
    }

    .back {
      margin-left: 52px;
      font-size: 16px;
      color: #999;
      cursor: pointer;
    }
  } 
`

export const Success = styled.div`
  padding-top: 120px;
  text-align: center;
  color: #333333;

  i {
    display: inline-block;
    width: 123px;
    height: 106px;
    background: url(${IconSuccess}) no-repeat;
    background-size: 100%;
  }

  .msg {
    margin-top: 40px;
    font-size: 20px;
  }

  .desc {
    margin-top: 16px;
    font-size: 16px;
    color: #666;
  }

  .regards {
    margin-top: 60px;

    p {
      margin-bottom: 16px;
      font-size: 20px;
    }

    a {
      display: inline-block;
      margin-top: 40px;
    }
  }
`

export const SuccessRoot = styled.div`
  padding-top: 105px;

  &.mobile {
    padding: 84px 12px 0;

    .apply {
      margin-top: 100px;

      h2 {
        font-size: 32px;
      }

      h3 {
        margin: 5px 0 20px;
        font-size: 18px;
      }

      .desc {
        font-size: 12px;
        text-align: center;
      }
    }

    .actions {
      margin-top: 64px;

      a {
        width: 135px;
      }
    }
  } 

  .apply {
    margin-top: 160px;
    display: flex;
    align-items: center;
    flex-direction: column;

    h2 {
      font-size: 40px;
      color: #C13329;
    }

    h3 {
      margin: 10px 0 12px;
      font-size: 28px;
      color: #333;
    }

    .desc {
      font-size: 16px;
      color: #999;
    }
  }

  .actions {
    margin-top: 64px;

    a {
      width: 200px;
      justify-content: center;
    }
  }
`